var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-container',{staticClass:"text-center"},[_c('h2',{staticClass:"mb-15"},[_vm._v("Tiro desviado…")]),_c('p',{staticClass:"lead"},[_c('strong',[_vm._v("Error 404, página no encontrada.")])])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }